// extracted by mini-css-extract-plugin
export default {"Member":"Member_Member__QCV4X","card":"Member_card__voJM+"};